import { currentUserIsSiteMemberOrSuperAdmin } from 'common/current_user';
import { View, ViewRight } from 'common/types/view';
import { hasRights } from 'common/views/has_rights';

/**
 * Tests to see if the current user is allowed to create derived reports off of
 * a default report.
 *
 * @returns if current user is site member or super admin.
 */
export function userCanCreateDerivedReports() {
  return currentUserIsSiteMemberOrSuperAdmin();
}

/**
 * Tests to see if the current derived view has rights to update, ie. save changes
 * made on the read-only story page via the Update button in the "Save changes" dropdown.
 *
 * @param derivedView the derived view to check. It doesn't really make sense to pop a
 * default view here.
 * @returns true if the view has the `write` right.
 */
export function userCanUpdateDerivedReport(derivedView: Partial<View> | undefined | null) {
  return hasRights(derivedView, ViewRight.Write);
}
